import { render } from "./PopinCandidate.vue?vue&type=template&id=52070af8"
import script from "./PopinCandidate.vue?vue&type=script&lang=js"
export * from "./PopinCandidate.vue?vue&type=script&lang=js"

import "./PopinCandidate.vue?vue&type=style&index=0&id=52070af8&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__